<template>
  <div class="upload-sessions" v-if="sessions.length > 0">
    <div class="summary d-flex align-items-center">
      <div>
        <CIcon name="cipDownload" size="custom-size" height="16"/>
      </div>
      <DownloadProgress
          class="m-2"
          :total-files="sessionSummary.totalFiles"
          :downloaded-files="sessionSummary.downloadedFiles"
      />
      <div class="perc" v-if="progressPercent < 100">
        {{ progressPercent }}%
      </div>
      <div v-if="hasFailedSession" class="ml-2">
        <CIcon name="cipAlertTriangle" class="text-danger" size="custom-size" height="18"/>
      </div>
      <div>
        <CButton
            class="btn-circle btn-circle--xs"
            color="dark"
            size="sm"
            variant="outline"
            @click="collapsed = !collapsed"
        >
          <CIcon :name="collapsed ? 'cipCaretUp' : 'cipCaretDown'"/>
        </CButton>
      </div>
    </div>

    <div v-if="!collapsed" class="sessions-list">
      <div class="title" v-translate translate-context="downloader.status">Downloads</div>
      <hr>
      <div class="content">
        <DownloadSession
            v-for="session in sessions"
            :key="session.id"
            :session="session"
            @cancel="onCancelSession"
            @close="onCloseSession"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DownloadSession from './DownloadSession.vue'
import DownloadProgress from './DownloadProgress.vue'
import downloadSessionStatus from '../downloadSessionStatus'

export default {
  name: 'DownloadStatus',
  components: {
    DownloadSession,
    DownloadProgress
  },
  data() {
    return {
      collapsed: false,
      autoCollapseTimeout: null
    }
  },
  beforeDestroy() {
    if (this.autoCollapseTimeout) {
      clearTimeout(this.autoCollapseTimeout)
    }
  },
  watch: {
    sessions(newSessions, oldSessions) {
      if (newSessions.length > oldSessions.length) {
        this.collapsed = false
      }
    },
    hasActiveDownload() {
      this.checkAutoCollapse()
    }
  },
  computed: {
    ...mapGetters('downloader', [
      'sessions',
      'sessionSummary',
      'hasActiveDownload'
    ]),
    progressPercent() {
      if (this.sessionSummary.totalFiles === 0) return 0
      return Math.floor((this.sessionSummary.downloadedFiles / this.sessionSummary.totalFiles) * 100)
    },
    hasFailedSession() {
      return this.sessions.some(s => s.status === downloadSessionStatus.failed)
    }
  },
  methods: {
    ...mapActions('downloader', [
      'cancelDownload',
      'removeSession'
    ]),
    onCancelSession(sessionId) {
      this.confirm({
        title: this.$gettext('Stop Download'),
        message: this.$gettext('Are you sure you want to cancel this download?'),
        color: 'danger',
        cb_confirm: () => {
          this.cancelDownload(sessionId)
        }
      })
    },
    onCloseSession(sessionId) {
      this.removeSession(sessionId)
    },
    checkAutoCollapse() {
      if (this.hasActiveDownload) {
        if (this.autoCollapseTimeout) {
          clearTimeout(this.autoCollapseTimeout)
          this.autoCollapseTimeout = null
        }
      } else {
        if (this.collapsed) return
        this.autoCollapseTimeout = setTimeout(() => {
          this.collapsed = true
        }, 5000)
      }
    }
  }
}
</script>

